import { render } from "./PlacementsForm.vue?vue&type=template&id=287fd66c"
import script from "./PlacementsForm.vue?vue&type=script&lang=js"
export * from "./PlacementsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__